module.exports = __webpack_public_path__ + "static/media/Quicksand-Medium.dce20268.woff2";